import { Role } from '@/domain/entities/Role'
import { AxiosResponse } from 'axios'
import { BaseResponseMapper } from './Base'

export class RoleDataMapper extends BaseResponseMapper {
  public converRoleListFromApi(result: AxiosResponse<any>): Role[] {
    const response = Array<Role>()
    const { data } = result.data

    data.forEach((item) => {
      const role = new Role(
        item.id_role,
        item.role_name,
        item.created_at,
        item.updated_at,
        item.access
      )
      response.push(role)
    })

    return response
  }
}
